var formEl = {
	first: true,
	current_data: {},
	bind: {
		select : function(callback) {
			$('.select-new .select-field-new').click(function(e) {
				e.preventDefault();
				var $this = $(this).parents('.select-new');
				if (!$this.hasClass('open')) {
					setTimeout(function() {
						$this.addClass('open');
					}, 10);
				} else {
					$this.removeClass('open');
					formEl.helpers.errors($this);
				}
			});
			$('.select-new .select-drop-down-menu ul li').click(function(e) {
				e.preventDefault();
				formEl.helpers.appendSelectItem($(this));
				if ($(this).parents('.select-new').hasClass('open')) {
					var $this = $(this).parents('.select-new');
					formEl.select.helpers.update($this, $(this));
					$(this).parents('.select-new').removeClass('open');
					formEl.helpers.errors($(this).parents('.select-new'));
				}
			});
			$('.select-new select').change(function(e){
				$(this).parents('.select-new').find('input').prop( 'value', $(this).val() );
				$(this).parents('.select-new').find('input').trigger('change');
			});
			if (typeof(callback) == 'function') {
				callback();
			}
		},
	},
	unbind: {
		select : function(callback) {
			$('.select-new .select-field-new').unbind('click');
			$('.select-new .select-field-new .select-drop-down-menu ul li').unbind('click');
			if (typeof(callback) == 'function') {
				callback();
			}
		},
	},
	rebind: {
		select: function() {
			formEl.unbind.select(function() {
				formEl.bind.select();
			});
		},
	},
	$availability : [],
	input : {
		bind : function(callback) {
			$('.input input, .textarea textarea').focusin(function(e) {
				var $this = $(this).parents('.input, .textarea');
				if (!$this.hasClass('focus')) {
					 $this.addClass('focus');
				}
			});
			$('.input input, .textarea textarea').focusout(function(e) {
				var $this = $(this).parents('.input, .textarea'),
						val = $(this).val();
				if ($this.hasClass('focus')) {
					$this.removeClass('focus');
				}
				$(this).val(val.trim());
				if ($this.hasClass('error-check')) {
					if ($(this).val().length > 0) {
						errors.formEl($this);
					}
				}
			});
			$('.input.error-check input, .textarea.error-check textarea').keyup(function() {
				var $this = $(this).parents('.input input, .textarea textarea');
				if ($this.hasClass('error')) {
					errors.formEl($this);
				}
			});
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		helpers : null,
		unbind : function(callback) {
			$('.input input, .textarea textarea').unbind('focusin');
			$('.input input, .textarea textarea').unbind('focusout');
			$('.input.error-check input, .textarea.error-check textarea').unbind('keyup');
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		init : function() {
			formEl.input.unbind(function() {
				formEl.input.bind();
			});
		},
	},
	submit : {
		bind : function(callback) {
			$('.fake-submit button').click(function(e) {
				e.preventDefault();
				$(this).parents('.fake-submit').find('input').click();
			});
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		helpers : null,
		unbind : function(callback) {
			$('.fake-submit .button').unbind('click');
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		init : function() {
			formEl.submit.unbind(function() {
				formEl.submit.bind();
			});
		},
	},
	select : {
		bind : function(callback) {
			$('.select .select-field').click(function(e) {
				e.preventDefault();
				var $this = $(this).parents('.select');
				formEl.select.helpers.open($this);
			});
			$('.select .drop-down ul li').click(function(e) {
				e.preventDefault();
				var $this = $(this).parents('.select');
				formEl.select.helpers.update($this, $(this));
				formEl.select.helpers.close($this);
			});
			$('.select .drop-down ul li').hover(function(e) {
				e.preventDefault();
				var $this = $(this).parents('.select');
				$this.find('.drop-down ul li').removeClass('active');
				$(this).addClass('active');
			}, function() {
				var $this = $(this).parents('.select');
				$this.find('.drop-down ul li').removeClass('active');
			});
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		helpers : {
			open : function($this) {
				if (!$this.hasClass('active') && !$this.hasClass('open')) {
					setTimeout(function() {
						if ( $this.hasClass( 'select-new') ) {
							setTimeout(function() {
								$this.addClass('open');
							}, 10);
						} else {
							$this.addClass('active');
							setTimeout(function() {
								$('body').icons.init( '.svg-icon' );
								$this.addClass('open');
							}, 10);
						}
					}, 10);
				}
			},
			close : function($this) {
				if ($this.hasClass('active') || $this.hasClass('open') ) {
					$this.removeClass('active');
					$this.removeClass('open');
				}
			},
			update : function($this, $li) {
				var val = $li.data('value'),
						label = val;
				if ( 'undefined' != typeof $li.data('label') ) {
					label = $li.data('label');
				}
				$this.find('.select-field .text, .select-field-new .text').html(label);
				$this.find('input').val(val);
				if ( 'text' == $this.find('input').attr('type') ) {
					$this.find('input').trigger('change');
				}
				$this.find('.drop-down ul li, .select-drop-down-menu ul li').removeClass('selected');
				$li.addClass('selected')
			},
			scrollToItem : function($this, fwd) {
				var $scroller = $this.parents('.drop-down'),
						oldPos = $scroller.scrollTop(),
						position = $this.position().top;
				if (fwd == 'reset-top') {
					$scroller.scrollTop(0);
				} else if (fwd == 'reset-bottom') {
					$scroller.scrollTop($scroller.find('ul').height());
				} else if (fwd == 'start') {
					position = position - (1 * $this.outerHeight(true));
					$scroller.scrollTop(position);
				} else if (fwd == true) {
					position = position - (3 * $this.outerHeight(true));
					if (oldPos < position) {
						$scroller.scrollTop(position);
					}
				}	else {
					position = position - (1 * $this.outerHeight(true));
					if (oldPos > position) {
						$scroller.scrollTop(position);
					}
				}
			}
		},
		unbind : function(callback) {
			$('.select .select-field').unbind('click');
			$('.select .drop-down ul li').unbind('click');
			$('.select .drop-down ul li').unbind('hover');
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		init : function() {
			formEl.select.unbind(function() {
				formEl.select.bind();
			});
		}
	},
	checkbox : {
		bind : function(callback) {
			$('.checkbox input').change(function() {
				var $this = $(this).parents('label');
				if ($(this).is(':checked')) {
					$this.addClass('active');
				} else {
					$this.removeClass('active');
				}
				if ($this.parents('.checkbox').hasClass('error-check') || $this.parents('.checkbox').hasClass('error')) {
					errors.formEl($this.parents('.checkbox'));
				}
				if ($this.parents('.checkbox').hasClass('no-date')) {
					errors.formEl($this.parents('.checkbox'));
				}
			});
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		helpers : null,
		unbind : function(callback) {
			$('.checkbox input').unbind('change');
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		init : function() {
			formEl.checkbox.unbind(function() {
				formEl.checkbox.bind();
			});
		}
	},
	radio : {
		bind : function(callback) {
			$('.radio input').change(function() {
				var $this = $(this).parents('label'),
						$radio = $this.parents('.radio');

				if (!$radio.hasClass('special')) {
					$(this).parents('label').removeClass('active');
					if ($(this).is(':checked')) {
						$this.addClass('active').siblings('label').removeClass('active');
					}
				} else {
					if ($(this).is(':checked')) {
						var height = $this.find('.label .drop-down .drop-down-inner').outerHeight(true),
								currentHeight = $radio.find('label.active .drop-down .drop-down-inner').outerHeight(true),
								tabHeight = $radio.parents('.tab').outerHeight(true) + height - currentHeight;
						$radio.find('.label .drop-down').css({'height' : 0});
						$this.find('.label .drop-down').css({'height' : height});
						$radio.find('label').removeClass('active');
						$this.addClass('active');
						$radio.parents('.tabs').css({'height' : tabHeight});
					}
				}
				if ($this.parents('.radio').hasClass('error-check') || $this.parents('.radio').hasClass('error')) {
					errors.formEl($this.parents('.radio'));
				}
			});
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		helpers : null,
		unbind : function(callback) {
			$('.radio input').unbind('change');
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		init : function() {
			formEl.radio.unbind(function() {
				formEl.radio.bind();
			});
		}
	},
	switch : {
		bind : function(callback) {
			$('.switch input').change(function() {
				var $this = $(this).parents('label'),
						$switch = $this.parents('.switch');
				$(this).parents('label').removeClass('active').addClass('inactive');
				if ($(this).is(':checked')) {
					$switch.removeClass('error');
					$switch.find('label').removeClass('active');
					$this.addClass('active').removeClass('inactive');
				}
				if ($this.parents('.switch').hasClass('error-check') || $this.parents('.switch').hasClass('error')) {
					errors.formEl($this.parents('.swich'));
				}
			});
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		helpers : null,
		unbind : function(callback) {
			$('.switch input').unbind('change');
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		init : function() {
			formEl.switch.unbind(function() {
				formEl.switch.bind();
			});
		}
	},
	change : {
		bind : function(callback) {
			$( formEl.change.helpers.$elem.join(',') ).change(function() {
				formEl.change.helpers.$selected_values[ $(this).attr('name') ] = '[data-' + $(this).attr('name') + '="' + $(this).val() + '"]';
				formEl.change.helpers.update();
			});
			$( 'input[name="s_not_lgp"]' ).change(function() {
				if ( $(this).is(':checked') ) {
					$('.show_lgp').addClass('hide');
				} else {
					$('.show_lgp').removeClass('hide');
				}
			});
			$( 'input[name="dln-vr6"]' ).change(function() {
				if ( 'geen pas' != $(this).val() ) {
					$('.pass').removeClass('hide');
					if ( 'u-pas' == $(this).val() ) {
						$('.pass .pass_amount').removeClass('hide');
					} else {
						$('.pass .pass_amount').addClass('hide');
					}
				} else {
					$('.pass').addClass('hide');
					$('.pass .pass_amount').addClass('hide');
				}
			});
			$( 'input[name="payment"]' ).change(function() {
				if ( '0' != $(this).closest('.radio').data('gt') ) {
					$('.iban').removeClass('hide');
				} else {
					$('.iban').addClass('hide');
				}
			});
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		helpers : {
			$selected_values : {},
			$elem : ['input[name="course_duration"]','input[name="course_type"]','input[name="course_freq"]'],
			update : function( callback ) {
				var $attr = formEl.change.helpers.$selected_values,
					$elem = $( 'input[name="rate_id"]' ).closest('.radio-group');

				//reset
				$elem.find('.radio').addClass('hide');
				$elem.find('.radio').removeClass('active').find('input').prop('checked', false);

				$attr = Object.values( $attr ).join('');

				if ( $elem.find('.radio' + $attr ).length > 0 ) {
					$elem.find('.label em').hide();
					$elem.find('.radio' + $attr ).removeClass('hide');
					// DISABLED
					// $elem.find('.radio' + $attr + ':first' ).addClass('active').find('input').prop('checked', true);

					// if ( $elem.find('.radio' + $attr ).length == 1 ) {
					// 	var $price = $elem.find('.radio' + $attr ).find('.text span').text();
					// 	var reg = /\d+/g;
					// 	$('.radio-group--pay .radio .text em').hide();
					// 	if ( $price.match(reg).length > 0 ) {
					// 		$('.radio-group--pay .radio').each(function(){
					// 			if ( $price.match(reg)[0] > $(this).data('gt') ) {
					// 				$(this).find('.text em').show();
					// 			}
					// 		});
					// 	}
					// }

					// if ( $elem.find('.radio' + $attr ).length == 1 && typeof(callback) == 'function') {
					// 	var $data = {};
					// 	$data['label'] = $elem.find('.radio' + $attr ).find('.text label').text();
					// 	$data['value'] = $elem.find('.radio' + $attr ).find('.text span').text();
					// 	callback( $data );
					// }
				} else {
					$elem.find('.label em').show();
				}
			}
		},
		unbind : function(callback) {
			$( formEl.change.helpers.$elem.join(',') ).unbind('change');
			if (typeof(callback) == 'function') {
				callback();
			}
		},
		init : function() {
			formEl.change.unbind(function() {
				formEl.change.bind();
			});
		}
	},
	helpers : {
		appendSelectItem : function($this) {
			var value = $this.data('value'),
					label = $this.data('label');

			$this.parents('.select-drop-down-menu').find('ul li').removeClass('active');
			$this.addClass('active');
			if (!$this.parents('.select-new').hasClass('active')) {
				$this.parents('.select-new').addClass('active');
			}

			$this.parents('.select-new').find('.select-field-new .text').html(value);
			$this.parents('.select-new').find('input').val(value);
		},
		errors : function($this, checker, callback) {
			if ($this.hasClass('error-check')) {
				var val = $this.find('input, textarea').val();
				if (typeof checker == 'undefined') {
					checker = $this.data('error');
				}
				inputErrors($this, checker, val, function($this, error, message) {
					if (error == true) {
						//console.log(message);
						$this.find('.note').html(message);
						$this.addClass('error');
					} else {
						$this.removeClass('error');
						if (typeof(callback) == 'function') {
							callback();
						}
					}
				});
			}
		},
	},
	globalHandlers : function() {
		$(document).on('click', function (e) {
			if ($('.select.open,.select-new.open').length != '') {
				if ($(e.target).closest(".select .drop-down").length === 0) {
					formEl.select.helpers.close($(".select.active"));
				}
				if ($(e.target).closest(".select-new .select-drop-down-menu").length === 0) {
					formEl.select.helpers.close($(".select-new.open"));
				}
			}
		});
		$(document).keydown(function(e){
			if (e.keyCode == 13) { // enter
				if ( $(e.target).parents( '.search-form' ).length == 0 ) {
					e.preventDefault();
					formEl.select.helpers.open( $( '.select input:focus' ).parents( '.field.select' ) );
					formEl.select.helpers.open( $( '.select-new input:focus' ).parents( '.field.select-new' ) );
				}
			}
			if ($('.field.select.open,.field.select-new.open').length != '') {
				if (e.keyCode == 38) { // up
					e.preventDefault();
					var $select = $('.field.select.open .drop-down ul, .field.select-new.open .select-drop-down-menu ul'),
							$new = null,
							fwd = false;
					if ($select.find('li.active').length == '') {
						if ($select.find('li.selected').length == '') {
							$select.find('li').last().addClass('active');
							$new = $select.find('li').last();
							fwd = 'reset-bottom';
						} else {
							$select.find('li.selected').addClass('active');
							$new = $select.find('li.selected');
						}
					} else {
						var _total = $select.find('li').size(),
								_old =  $select.find('li.active').index(),
								_new = _old - 1;
						if (_new < 0) {
							_new = _total - 1;
							fwd = 'reset-bottom';
						}
						$select.find('li.active').removeClass('active');
						$select.find('li').eq(_new).addClass('active');
						$new = $select.find('li').eq(_new);
					}
					formEl.select.helpers.scrollToItem($new, fwd);
				} else if (e.keyCode == 40) { // down
					e.preventDefault();
					var $select = $('.field.select.open .drop-down ul, .field.select-new.open .select-drop-down-menu ul'),
							$new = null,
							fwd = true;
					if ($select.find('li.active').length == '') {
						if ($select.find('li.selected').length == '') {
							$select.find('li').first().addClass('active');
							$new = $select.find('li').first();
							fwd = 'reset-top';
						} else {
							$select.find('li.selected').addClass('active');
							$new = $select.find('li.selected');
						}
					} else {
						var _total = $select.find('li').size(),
								_old = $select.find('li.active').index(),
								_new = _old + 1;
						if (_new >= _total) {
							_new = 0;
							fwd = 'reset-top';
						}
						$select.find('li.active').removeClass('active');
						$select.find('li').eq(_new).addClass('active');
						$new = $select.find('li').eq(_new);
					}
					formEl.select.helpers.scrollToItem($new, fwd);
				} else if (e.keyCode == 13) { // enter
					e.preventDefault();
					var $this = $('.field.select.open,.field.select-new.open'),
							$li = $this.find('li.active');
					formEl.select.helpers.update($this, $li);
					formEl.select.helpers.close($this);
				}
			}
		});
	},
	avail : function(callback) {
		// $.ajax({
		// 	url: customdata.ajaxURL,
		// 	data: { action : 'get_availability' },
		// 	method: 'post',
		// 	asynch: false,
		// 	cache: false,
		// })
		// .success( function(thisdata, textStatus, jqCHR) {
		// 	var json = $.parseJSON( thisdata );
		// 	if ( 'undefined' == typeof json.errors ) {
		// 		formEl.$availability = json;
		// 	}
		// 	if (typeof(callback) == 'function') {
		// 		callback();
		// 	}
		// });
	},
	payment : {
		init : function() {
			// default data:
			formEl.current_data['price'] = 0;
			formEl.payment.update();
			if ( $('input[name="rate_id"]').length > 0 ) {
				var $value = $('input[name="rate_id"]').closest('.radio').data('price');
				formEl.current_data['price'] = $value;
				formEl.payment.update();
			}
		},
		update : function() {
			$('.radio-group--pay .radio[data-gt]').each(function(){
				$(this).closest('.radio').removeClass('disabled');
				$(this).find('input').removeAttr('disabled');
				if ( 'undefined' != typeof $(this).data('gt')
					&& formEl.current_data['price'] < $(this).data('gt') ) {
					$(this).closest('.radio').addClass('disabled');
					$(this).closest('.radio').removeClass('active');
					$(this).find('input').prop('disabled','disabled');
					$(this).find('input').prop('checked',false);
				}
			});
		}
	},
	init: function() {
		formEl.globalHandlers();
		formEl.input.init();
		formEl.submit.init();
		formEl.select.init();
		formEl.checkbox.init();
		formEl.radio.init();
		formEl.switch.init();
		formEl.change.init();
		formEl.avail(function(){
			formEl.datepicker.init();
		});
		formEl.payment.init();
		if (formEl.first == true) {
			formEl.first = false;
			formEl.bind.select();
		} else {
			formEl.rebind.select();
		}
	}
}
